/*
  accessible-menu.js - WCAG 2.2 AA remediation (Fix 4)
  Progressive enhancement for the desktop mega-menu (.thb-full-menu).
  Additive only - does not modify the theme's minified bundles, and does NOT
  bind any mouse handlers, so it can never suppress the native hover menu.

  For each top-level item that has a submenu it adds:
    - a managed aria-expanded state (announced collapse/expand)
    - aria-controls wired to the submenu element
    - keyboard control: ArrowDown / Space opens, Esc closes and returns focus,
      Arrow keys move between submenu links
*/
(function () {
  'use strict';

  function init() {
    var toggles = document.querySelectorAll('.thb-full-menu > li.menu-item-has-children > a[data-submenu-toggle]');
    if (!toggles.length) return;

    toggles.forEach(function (toggle, i) {
      var li = toggle.closest('li.menu-item-has-children');
      var submenu = li ? li.querySelector(':scope > .sub-menu') : null;
      if (!submenu) return;

      if (!submenu.id) submenu.id = 'submenu-' + (i + 1);
      toggle.setAttribute('aria-controls', submenu.id);

      function links() {
        return Array.prototype.slice.call(submenu.querySelectorAll('a[href]'))
          .filter(function (a) { return a.offsetParent !== null; });
      }

      function open() {
        li.classList.remove('a11y-collapsed');
        toggle.setAttribute('aria-expanded', 'true');
      }
      function close() {
        toggle.setAttribute('aria-expanded', 'false');
      }
      // Esc: keep focus on the toggle but force the submenu shut.
      function collapse() {
        li.classList.add('a11y-collapsed');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }

      // Hover is left entirely to the theme's native CSS. Keyboard only here:
      li.addEventListener('focusin', function () { li.classList.remove('a11y-collapsed'); open(); });
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) { li.classList.remove('a11y-collapsed'); close(); }
      });

      // Keyboard on the top-level toggle link.
      toggle.addEventListener('keydown', function (e) {
        switch (e.key) {
          case 'ArrowDown':
          case 'Down': {
            e.preventDefault();
            open();
            var l = links();
            if (l.length) l[0].focus();
            break;
          }
          case ' ':
          case 'Spacebar': {
            // Space toggles; Enter is left alone so the link still navigates.
            e.preventDefault();
            if (toggle.getAttribute('aria-expanded') === 'true' && !li.classList.contains('a11y-collapsed')) {
              collapse();
            } else {
              open();
              var l2 = links();
              if (l2.length) l2[0].focus();
            }
            break;
          }
          case 'Escape':
          case 'Esc':
            e.preventDefault();
            collapse();
            break;
        }
      });

      // Keyboard inside the submenu.
      submenu.addEventListener('keydown', function (e) {
        var l = links();
        var idx = l.indexOf(document.activeElement);
        switch (e.key) {
          case 'Escape':
          case 'Esc':
            e.preventDefault();
            collapse();
            break;
          case 'ArrowDown':
          case 'Down':
            e.preventDefault();
            if (l.length) l[(idx + 1) % l.length].focus();
            break;
          case 'ArrowUp':
          case 'Up':
            e.preventDefault();
            if (l.length) l[(idx - 1 + l.length) % l.length].focus();
            break;
          case 'Home':
            e.preventDefault();
            if (l.length) l[0].focus();
            break;
          case 'End':
            e.preventDefault();
            if (l.length) l[l.length - 1].focus();
            break;
        }
      });
    });

    // Click outside an open item clears the collapsed flag.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.thb-full-menu > li.menu-item-has-children')) {
        document.querySelectorAll('.thb-full-menu > li.menu-item-has-children.a11y-collapsed')
          .forEach(function (li) { li.classList.remove('a11y-collapsed'); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
